/* ======================================================
   DRIVER LICENSE TYPES
====================================================== */

export const DRIVER_LICENSE_TYPES = [

  {
    value: "A1",
    label: "A1"
  },

  {
    value: "A2",
    label: "A2"
  },

  {
    value: "A3",
    label: "A3"
  },

  {
    value: "B1",
    label: "B1"
  },

  {
    value: "B2",
    label: "B2"
  },

  {
    value: "B3",
    label: "B3"
  },

  {
    value: "C1",
    label: "C1"
  },

  {
    value: "C2",
    label: "C2"
  },

  {
    value: "C3",
    label: "C3"
  }

];